module.exports = __webpack_public_path__ + "static/media/icon-add.4f13a2a9.svg";